module.exports = __webpack_public_path__ + "static/media/Arsh_Maknojia.d3c22882.jpg";